import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GlobalsService } from '@app/services/globals.service';
import { PassengerService } from '@app/services/passenger.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageGuard implements CanActivate,CanActivateChild {

  constructor(
    private _globalService: GlobalsService,
    private _passengerService: PassengerService
  ) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    this.saveStorage();
    return true;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.saveStorage();
    return true;
  }

  saveStorage() {
    this.savePassengerSelections();
  }

  savePassengerSelections() {
    let passengers = this._passengerService.getPassengerSelection(true);
    passengers?.map(passenger=> this._globalService.setPassenger(passenger));
  }
}
